import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { Query, QueryGetVisitorGroupsForTenantArgs } from 'graphql/generated/graphqlTypes';
import { GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS } from 'graphql/queries';
import { useEffect } from 'react';
import { setVisitorGroupsMembersAction } from 'state/actions/visitorGroupsMembers';
import { visitorsGroupsMembersVar } from 'state/vars';
import { BaseHookProps } from '../shared/types';

const useVisitorsGroupsMembers = ({ handleFetchError }: BaseHookProps) => {
  const visitorsGroupsMembers = useReactiveVar(visitorsGroupsMembersVar);

  const [getVisitorsGroupsMembers, { loading }] = useLazyQuery<
    Pick<Query, 'getVisitorGroupsForTenant'>,
    QueryGetVisitorGroupsForTenantArgs
  >(GET_VISITOR_GROUPS_FOR_TENANT_WITH_MEMBERS, {
    onCompleted: (data) => {
      setVisitorGroupsMembersAction(data.getVisitorGroupsForTenant);
    },
    onError: () => {
      handleFetchError('Error while fetching visitor groups');
    }
  });

  useEffect(() => {
    getVisitorsGroupsMembers();
  }, [getVisitorsGroupsMembers]);

  return {
    visitorsGroupsMembers,
    loading
  };
};

export default useVisitorsGroupsMembers;
